var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type,{tag:"component",staticClass:"button",class:[_vm.design, _vm.disabled ? 'disabled' : ''],style:({
        width: _vm.width,
        height: _vm.height,
    }),attrs:{"type":_vm.buttonType,"to":_vm.to,"href":_vm.href,"target":_vm.target,"rel":_vm.rel,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }